"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyVersionOverride = void 0;
const client_1 = require("@wix/cashier-common/dist/src/utils/queryParams/client");
const config_1 = require("./config");
const applyVersionOverride = (settings) => {
    const { widgetStaticsBaseUrl, widgetVersion } = settings;
    try {
        const versionOverride = (0, client_1.getVersionOverrideFromQueryParams)(config_1.ARTIFACT_NAME);
        if (versionOverride) {
            settings.widgetVersion = versionOverride;
            settings.widgetStaticsBaseUrl = widgetStaticsBaseUrl.replace(widgetVersion, versionOverride);
        }
    }
    catch (e) {
        console.error(`Failed to apply version override`, e);
        // restore original values
        settings.widgetVersion = widgetVersion;
        settings.widgetStaticsBaseUrl = widgetStaticsBaseUrl;
    }
    return settings;
};
exports.applyVersionOverride = applyVersionOverride;
//# sourceMappingURL=applyVersionOverride.js.map